import React from "react";
import CountUp from "react-countup";

const stats = [
  { number: 50, suffix: "+", title: "Projects Delivered" },
  { number: 98, suffix: "%", title: "Client Satisfaction" },
  { number: 10, suffix: "+", title: "Years of Experience" },
  { number: 10, suffix: "+", title: "Industries Served" },
];

export default function StatsCounter() {
  return (
    <div className="bg-[#F8F8FC]">
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 text-center">
          {stats.map((item, index) => (
            <div key={index}>
              <h2 className="text-5xl font-bold text-[#355dff]">
                <CountUp
                  start={0}
                  end={item.number}
                  duration={2}
                  suffix={item.suffix}
                  enableScrollSpy={true}
                  scrollSpyOnce={true}
                />
              </h2>
              <p className="mt-3 text-[#70759A] text-lg">{item.title}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
